export default __webpack_public_path__ + "static/media/DSC29006.20b2b4c3.jpg";